const groozForm = () => {
    
    var grooz_options = {
        beforeSubmit: function(arr, $form, options) {            
            $($form).find('button').html('Wysyłka w trakcie ...');
        },
        success: function(responseText, statusText, xhr, $form) {
            if (responseText != "") {
                var response  = $.parseJSON(responseText);
                
                if(response.success != true){
                    $($form).find('button').html('Wyślij');
                } else {     
                    $($form).find('button').html('Dziękujemy :)');
                    $($form).find('input').val('');
                }
                
            } else {
                $($form).find('button').html('Wyślij');
            }
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $($form).find('button').html('Wyślij');
        }
    }; 

    $('#grooz-form').validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
            },
            accept: {
                accept: true,
            },
        },
        messages: {
            email: {
                required: "Wymagane",
                email: "Zły format e-mail"
            },
            phone: {
                required: "Wymagane",
            },
            accept: {
                required: "Wymagane",
            },
        },
        errorElement: 'span',
        errorPlacement: function(error, element) {
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            //ajax?
            $(form).ajaxSubmit(grooz_options);
        }
    });

 }
 
 module.exports = {
    groozForm, 
 };